import { getPhoneStoreState } from '@hit/react-jssip';
import { useAtomValue } from 'jotai/react';
import { useEffect, useRef } from 'react';

import { useDesktopCall } from '@/api/desktop-call';
import { useExtensionPermissions } from '@/api/use-extension-permissions';
import { useMode } from '@/hooks/use-mode';
import { useProvider } from '@/hooks/use-provider';
import { authenticatedAtom } from '@/lib/store';
import { PROVIDERS } from '@/providers';
import { openWidget } from '@/utils/open-widget';

export const useClickToDial = () => {
  const [provider] = useProvider();
  const mode = useMode();
  const { data: permissions } = useExtensionPermissions();
  const isAuthenticated = useAtomValue(authenticatedAtom);
  const { mutateAsync: callDesktop } = useDesktopCall();
  const alreadySetOnClickToDial = useRef(false);

  useEffect(() => {
    if (
      alreadySetOnClickToDial.current ||
      provider.id !== PROVIDERS.SALESFORCE ||
      mode === 'loading' ||
      !permissions ||
      !isAuthenticated
    ) {
      return;
    }

    provider.enableClickToDial(async (number) => {
      try {
        if (mode === 'webrtc') {
          const { phone } = getPhoneStoreState();
          phone?.call(number);
        } else {
          await callDesktop({ number });
        }
        openWidget();
        if (isAuthenticated && provider.id === PROVIDERS.SALESFORCE) {
          await provider.logCall({ contactId: number });
        }
      } catch (error) {
        console.warn(error);
      }
    });
    alreadySetOnClickToDial.current = true;
  }, [mode, permissions, provider, callDesktop, isAuthenticated]);
};
